// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProjectList from './components/ProjectList';
import ProjectCreate from './components/ProjectCreate';
import ProjectDetail from './components/ProjectDetail';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <header className="bg-white shadow-sm">
          <div className="container mx-auto py-4 px-4">
            <h1 className="text-xl font-bold text-gray-800">
              ヒアリング管理システム
            </h1>
          </div>
        </header>
        
        <main className="py-4">
          <Routes>
            <Route path="/" element={<ProjectList />} />
            <Route path="/create" element={<ProjectCreate />} />
            <Route path="/:id" element={<ProjectDetail />} />
          </Routes>
        </main>
        
        <footer className="bg-white py-4 border-t">
          <div className="container mx-auto px-4 text-center text-gray-500">
            &copy; 2025 Haruno Design
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;